'use client';
import * as React from 'react';
import Link from 'next/link';
import { List, ListItemText, Typography } from '@mui/material';
// import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import { useCurrentPath } from '@/shared/hooks';

const sidebarItems = [
  { label: 'Profilo', path: '/profilo/me' },
  { label: 'Strumenti', path: '/profilo/strumenti' },
  { label: 'Sessioni', path: '/profilo/sessioni-studio' },
  { label: 'Acquisti', path: '/profilo/acquisti' },
  { label: 'Cambia password', path: '/profilo/cambia-password' },
];

const ProfileSidebar: React.FC = () => {
  const [, isCurrentPath] = useCurrentPath();

  return (
    <span className="hidden lg:inline-block">
      <nav className=" bg-paper py-4 flex flex-col absolute inset-y-0 left-0 top-[90px] w-[264px]">
        <List style={{ flexGrow: 1 }}>
          {sidebarItems.map((item) => (
            <Link href={item.path} key={item.path} passHref>
              <ListItemText
                primary={<Typography variant="button-xl">{item.label}</Typography>}
                className={`px-6 pt-6 m-0 w-full whitespace-nowrap cursor-pointer ${
                  isCurrentPath(item.path) ? 'text-primary-main' : ''
                }`}
              />
            </Link>
          ))}
        </List>
        {/* <div className="px-6 mt-auto">
          <Button
            variant="text"
            startIcon={<LogoutRoundedIcon className="h-[24px]" />}
            style={{ padding: '0px' }}
            className="hover:bg-transparent text-text-primary"
          >
            <Typography variant="button-l">Logout</Typography>
          </Button>
        </div> */}
      </nav>
    </span>
  );
};

export { ProfileSidebar };
